export { default } from './PlaceholderCard';
export * from './PlaceholderCard';
